import { render, staticRenderFns } from "./brand-category.vue?vue&type=template&id=858e9ac2&scoped=true&"
import script from "./brand-category.vue?vue&type=script&lang=js&"
export * from "./brand-category.vue?vue&type=script&lang=js&"
import style0 from "./brand-category.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./brand-category.vue?vue&type=style&index=1&id=858e9ac2&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858e9ac2",
  null
  
)

export default component.exports